/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-notification-new': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 11V9.375H15v1.875a.569.569 0 00.188.438l1.687 1.687v1H3.125v-1l1.688-1.688A.569.569 0 005 11.25V8.125a5 5 0 015-5c.88 0 1.742.235 2.5.681V2.375a6.069 6.069 0 00-1.875-.5V.625h-1.25v1.25a6.344 6.344 0 00-5.625 6.25V11l-1.688 1.688a.569.569 0 00-.187.437V15a.587.587 0 00.625.625h4.375a3.125 3.125 0 006.25 0H17.5a.587.587 0 00.625-.625v-1.875a.569.569 0 00-.188-.438L16.25 11zM10 17.5a1.875 1.875 0 01-1.875-1.875h3.75c0 1.036-.84 1.875-1.875 1.875zm6.25-10a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"/>'
  }
})
